import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import storageNutritionAllergenBG from '../media/visituspagebackground.jpg'; // '../media/newstoragebackground.jpg'; // '../media/holidaybigBG3.jpg'
import mapleBottleBG from '../media/mapleweekendbottle.jpg'
import paper1 from '../media/unlinedpaper.jpg';
import paper2 from '../media/unlinedpaper.jpg'
import paper3 from '../media/unlinedpaper.jpg'
import salesFlyer from '../media/updates 2020/salesflyerpic.jpg';

const MapleWeekendSection = (props) => {

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
	    	<StoryDiv>
	    		<Row>
	    			{/*
	    			<LeftCol xs="12" md="4">
	    				<a target="_blank" href="https://www.mytwintiers.com/news-cat/pennsylvania-news/from-syrup-to-maple-mustard-celebrating-maple-weekend-at-patterson-farms-in-westfield-pa/">
		    				<FarmImg src={require("../media/storyfarmpic.jpg")}> 

		    				</FarmImg>
	    				</a>
	    			</LeftCol>

	    			<RightCol>
			    		<h3>From syrup to maple mustard: Celebrating Maple Weekend at Patterson Farms in Westfield, PA.</h3>
			    		<p>WESTFIELD, PA. (WETM) - With 200 acres and 80,000 maple trees to tap, Patterson Farms in Westfield, PA
			    		   is the largest maple producer in Pennsylvania.</p>
					 	<a target="_blank" href="https://www.mytwintiers.com/news-cat/pennsylvania-news/from-syrup-to-maple-mustard-celebrating-maple-weekend-at-patterson-farms-in-westfield-pa/">
					  		www.mytwintiers.com
					    </a>
	    			</RightCol>
	    			*/}

	    			<LeftCol>
			    		<h3>Welcome to another episode of Explore The Possibilities with Visit Potter-Tioga</h3>
			    		<p>Terri and Terry Patterson, 4th generation maple producers at Patterson Farms, give some insight on their family business, 
			    		   the growth it has seen over the years, the amazing products they have available, and the sights you get to see when visiting.</p>
					 	<a target="_blank" href="https://www.facebook.com/permalink.php?story_fbid=1741980479307918&id=264986307007350">
					  		Visit Potter-Tioga
					    </a>
	    			</LeftCol>

	    			<RightCol xs="12" md="4">
						<a target="_blank" href="https://www.facebook.com/permalink.php?story_fbid=1741980479307918&id=264986307007350">
								<FarmImg src={require("../media/visitpottertioga.jpg")}> 

								</FarmImg>
							</a>
	    			</RightCol>
	    		</Row>
	    		
	    		

	    	</StoryDiv>
		  
		  {/*
		  <BottleDiv>
			  <BottleImg src={require("../media/mapleweekendbottle.png")}>

			  </BottleImg>
			  <TextInBottleDiv>
				  <h3>Come Check Out Our Maple Weekend!</h3>
				  <p>
				   	  On March 20th and 21st, 2021, from 10am to 4pm, Patterson Farms will be participating in the
				   	  17th annual Potter / Tioga County Maple Weekend! Come join us for a fun filled 
				   	  weekend of demonstrations, tours, samples of pancakes and maple sausage, history, and much more!
				  </p>
			  </TextInBottleDiv>

		  </BottleDiv>
		 */}



		  {/*
		  <SaleDiv>
		      <h1>Apple Butter Special!</h1>

			  
			Three commented things below were right here 2.23.21 



			  <p>Once again available while supplies last, is <b>Linda's Apple Butter</b>!
			  It comes in 8 oz and is $5.00 online (click below) or $4.00 at the sugarhouse (come see us!)</p>
			  <ProductLink to="/Shop">
				<ProductImg src={require("../media/186.jpg")}></ProductImg>
			  </ProductLink>

		  </SaleDiv>
			*/}



			{/*<p>Spend $25.00 or more, and you will receive a <b>FREE</b> 1 pound bag of Maple Crunchies (a $9.50 value!!!) Valid until June 30th.</p>*/}

			  {/*
			  	THESE WERE BOTH IN SaleDiv ABOVE, and the line above 2.23.21. Just moved for commenting reasons
			  <ProductLink to="/Shop">
				<ProductImg src={require("../media/31.jpg")}></ProductImg>
			  </ProductLink>
			  */
			  }
			  {/*
			  <p>A new product, Bourbon Infused Maple Syrup, is now available! It is aged in a whiskey barrel, which gives it a
			  	 delicious bourbon flavor. It comes in our 200ml flask, in amber rich or robust, and is $10.50 online, or, $9.50 at the sugarhouse! 
			  	 Taste testing is available at the sugarhouse. <b>Limited supplies available!</b></p>
			  */}



		  {/*
		  <div>

		    <h1>March Madness Special</h1>
			<SalesFlyerImg src={require("../media/updates 2020/salesflyerpic.jpg")}></SalesFlyerImg>

		  </div>
		*/}

	    </InternalContainer>
	  </FluidContainer>
	); 
};

const StoryDiv = styled.div`
	p { color: black; }
`;

const FarmImg = styled.img`
	width: 100%;
	height: auto; 
	display: inline;


`;

const LeftCol = styled(Col)`
	${media.md`  
	a { color: sandybrown!important; }
	`}
	h3 { color: black!important; }
`;

const RightCol = styled(Col)`
	margin-bottom: 15px;
	${media.md` margin-bottom: auto; `}
`;




const SaleDiv = styled.div`
	p { color: white; }
`;
const ProductLink = styled(Link)`
	u { color: white; }
`;
const ProductImg = styled.img`
	width: 60%;
	height: auto;
	transition: all 0.5s;
	:hover { transform: translateY(6px); }
`;

const SalesFlyerImg = styled.img`
	width: 100%;
	height: 400px;
	${media.sm` height: 600px; `}
	${media.md` width: 80%; height: 650px;  `}
	${media.lg` width: 70%; height: 700px; `}
	${media.xl` width: 65%; height: 750px; `}
	${media.xxl` `}
`

const VideoContainer = styled.div`
	position: relative;
	padding-bottom: 65.25%;
	padding-top: 25px;
	height: 0;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`;


const BottleDiv = styled.div`
	position: relative;

	h3 { text-align: center; color: white; ${media.sm` color: black;`}}
	p { 
		color: white;
		text-align: left; 
		${media.sm` `}
		${media.md`  `}
		${media.lg`  `}
		${media.xl`  `}
		${media.xxl` `}
	}
`;

const TextInBottleDiv = styled.div`
	${media.sm` 
		width: 70%;
		position: absolute;
	    top: 57%;
	    left: 50%;
	    transform: translate(-50%, -50%);
	`}
	${media.md` width: 55%; top: 60%;`}
	${media.lg` width: 40%; top: 66%; `}
	${media.xl` width: 35%;`}

`;

const BottleImg = styled.img`
	display: none;

	${media.sm` width: 85%; height: auto; display: inline;`}
	${media.md` width: 70%;`}
	${media.lg` width: 52%;`}
	${media.xl` width: 45%;`}

`;



const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${storageNutritionAllergenBG}); 
	
	/*
    background-size: 100%; /* size the background image at 100% like any responsive img tag */
    background-position: top center;
    background-repeat:no-repeat;
    */
`;

const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
		color: black;
		${media.sm` color: white;`}
	}
`;

const ButtonStyled = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 250px;
  ${media.sm` width: 290px; `}
  
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 15px 0 0 0;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;





const PaperImgsRow = styled(Row)`
	h3 { padding: 0px 0 24px 0; margin: 0; }
	h4 { font-weight: bold!important; }
`;

const PaperImgCol1 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper1});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol2 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper2});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol3 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper3});  padding: 20px 12px 20px 12px; }
`;

const PaperImg = styled.img`
	height: auto;
	width: 100%;
	position: absolute;

`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default MapleWeekendSection;


// WEBPACK FOOTER //
// ./src/components/MapleWeekendSection.js